import { EMAIL_TYPE } from "../../event-create/containers/step-3/constants";

const validateEmail = (email) => {
  return email?.match(
    /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  );
};

const formatPhoneNumber = (input) => input?.length === 12 && input.startsWith("91") ? input.slice(2) : input;

const validateIndividualConfig = (config, activeAttendeeValue, userData) => {
  let err = {};
  if (config?.isRequired && !activeAttendeeValue?.[config?.id]?.length) err[config.id] = 'This is a required field';
  if (config?.label === 'Phone Number' && config?.isPreset) {
    if (formatPhoneNumber(activeAttendeeValue?.[config?.id])?.length !== 10) {
      err[config.id] = 'Enter a valid phone number';
    }
    // else if (!userData?.isPhoneVerified) {
    //   err[config.id] = 'Phone number not verified';
    // }
  }
  if (config?.type === EMAIL_TYPE) {
    if (config?.showSpecific) {
      if (config?.options?.every((option) => !activeAttendeeValue?.[config?.id]?.includes(option?.value))) {
        const validEmailIds = config?.options?.map((item) => item?.value)?.join(', @');
        err[config.id] = `Only @${validEmailIds} are allowed`;
      }
    } else if (!validateEmail(activeAttendeeValue?.[config?.id])) {
      err[config.id] = 'Enter a valid email id';
    }
  }

  return err;
};

const checkIsPerTicket = (array) => {
  return array?.some(obj => obj.is_question_per_transaction === false);
};

export {
  validateEmail,
  formatPhoneNumber,
  validateIndividualConfig,
  checkIsPerTicket,
};